import { render } from "./QuestionAnswerVariants.vue?vue&type=template&id=25177fd0&scoped=true&ts=true"
import script from "./QuestionAnswerVariants.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswerVariants.vue?vue&type=script&lang=ts"

import "./QuestionAnswerVariants.vue?vue&type=style&index=0&id=25177fd0&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25177fd0"]])

export default __exports__